/*
 * 拖拽事件绑定
 * 当options.drop为true时调用, 通过drop_id为dom绑定事件
 * 1. drop_folder为true时，调用dropFolderReader扫描文件夹内文件
 * 2. drop_folder为false，调用用dropFileReader查询拖拽内容是否有文件夹
 * @author sy
 * @date 2018-3-23
 */

/**
 * 验证拖拽文件是否为文件夹
 * @param files
 * @returns {Promise<any>}
 */

async function dropFileReader (files) {
  let ps = []
  for (let f of files) {
    ps.push((async function (f) {
      return new Promise((resolve, reject) => {
        if (f.size > 5000000) {
          resolve(f)
        } else {
          let fr = new FileReader()
          fr.readAsDataURL(f)
          fr.onload = e => {
            resolve(f)
          }
          fr.onerror = e => {
            const err = new Error('folder is not allowed!')
            err.file = f
            reject(err)
          }
        }
      })
    })(f))
  }
  const result = await Promise.all(ps).then(res => {
    let fs = []
    for (let o of res) {
      fs.push(o)
    }
    return fs
  })
  return result
}

/**
 * 拖拽文件或文件夹处理
 * @param entries
 * @returns {Promise<any>}
 */

async function dropFolderReader (entries) {
  let ps = []
  for (let e of entries) {
    let entry = e.webkitGetAsEntry()
    ps.push((async function (entry) {
      if (entry.isDirectory) {
        const re = await readEntries(entry)
        return re
      } else {
        const fc = await fileConvert(entry)
        return fc
      }
    })(entry))
  }
  const result = await Promise.all(ps).then(res => {
    let fs = []
    for (let o of res) {
      if (Array.isArray(o)) {
        fs = fs.concat(o)
      } else {
        fs.push(o)
      }
    }
    return fs
  })
  return result
}

/**
 * 读取文件夹下文件
 * @param entry
 * @returns {Promise<any>}
 */

function readEntries (entry) {
  return new Promise(resolve => {
    entry.createReader().readEntries(res => {
      let fs = []
      let flag = 0
      for (let j = 0; j < res.length; j++) {
        if (res[j].isFile) {
          fileConvert(res[j]).then(f => {
            flag++
            if (f.name.indexOf('.') !== 0) fs.push(f)
            if (flag === res.length) resolve(fs)
          })
        } else {
          throw new Error('Another folder is not allowed under the folder!')
        }
      }
    })
  })
}

/**
 * 转换文件对象
 * @param entry
 * @returns {Promise<any>}
 */

function fileConvert (entry) {
  return new Promise(resolve => {
    entry.file(f => {
      resolve(f)
    })
  })
}

export default function dropUpload (options, callback) {
  let dropBox = document.createElement('div')
  dropBox.setAttribute('id', 'drop_box')
  // dropBox.style.pointerEvents = 'none'
  document.body.appendChild(dropBox)
  document.addEventListener('dragenter', (e) => {
    e.preventDefault()
  })
  document.addEventListener('dragover', (e) => {
    e.preventDefault()
  })
  document.addEventListener('dragleave', (e) => {
    e.preventDefault()
  })
  document.addEventListener('drop', (e) => {
    e.preventDefault()
  })
  // let lastenter
  let dropTarget = document.querySelector('#' + options.drop_id)
  dropTarget.addEventListener('dragenter', (e) => {
    dropBox.setAttribute('class', 'dragenter')
    e = window.event || e
    // lastenter = window.event.srcElement
    if (document.all) {
      e.returnValue = false
      e.cancelBubble = true
    } else {
      e.preventDefault()
      e.stopPropagation()
    }
  })
  dropTarget.addEventListener('dragover', (e) => {
    e = window.event || e
    if (document.all) {
      e.returnValue = false
      e.cancelBubble = true
    } else {
      e.preventDefault()
      e.stopPropagation()
    }
  })
  dropTarget.addEventListener('dragleave', (e) => {
    e = window.event || e
    // if (window.event.srcElement === lastenter) {
    //   dropBox.setAttribute('class', 'dragleave')
    // }
    if (document.all) {
      e.returnValue = false
      e.cancelBubble = true
    } else {
      e.preventDefault()
      e.stopPropagation()
    }
  })
  dropTarget.addEventListener('drop', (e) => {
    if (e.dataTransfer.files.length !== 0) {
      if (!options.drop_folder) {
        (async function (files) {
          try {
            let fs = await dropFileReader(files)
            callback(null, e, fs)
          } catch (err) {
            callback(err, e, files)
          }
        })(e.dataTransfer.files)
      } else {
        (async function (files) {
          try {
            let fs = await dropFolderReader(files)
            callback(null, e, fs)
          } catch (err) {
            callback(err, e, files)
          }
        })(e.dataTransfer.items)
      }
    } else {
      const err = new Error('folder is not allowed!')
      err.file = {}
      callback(err)
    }
    dropBox.setAttribute('class', 'dragleave')
    // lastenter = null // 解决dragleave父子元素之间的拖拽问题
    e.preventDefault()
  })
  dropBox.addEventListener('dragenter', (e) => {
    e = window.event || e
    if (document.all) {
      e.returnValue = false
      e.cancelBubble = true
    } else {
      e.preventDefault()
      e.stopPropagation()
    }
  })
  dropBox.addEventListener('dragleave', (e) => {
    e = window.event || e
    dropBox.setAttribute('class', 'dragleave')
    if (document.all) {
      e.returnValue = false
      e.cancelBubble = true
    } else {
      e.preventDefault()
      e.stopPropagation()
    }
  })
  dropBox.addEventListener('drop', (e) => {
    try {
      // eslint-disable-next-line
      let listDatasLth = $('#body-list').find('tr').length
      // GY,5.1BUG,私有云PCS-1236,上传审批列表显示的文件有误
      if (listDatasLth > 0 && localStorage.approveExist === 'true') {
        // eslint-disable-next-line
        $('#body-list').html('')
      }
      if (localStorage.approveExist) {
        window.isDraged = true
      } else {
        window.isDraged = false
      }
    } catch (err) {
      console.log(err)
    }
    if (e.dataTransfer.files.length !== 0) {
      if (!options.drop_folder) {
        (async function (files) {
          try {
            let fs = await dropFileReader(files)
            callback(null, e, fs)
          } catch (err) {
            callback(err, e, files)
          }
        })(e.dataTransfer.files)
      } else {
        (async function (files) {
          try {
            let fs = await dropFolderReader(files)
            callback(null, e, fs)
          } catch (err) {
            callback(err, e, files)
          }
        })(e.dataTransfer.items)
      }
    } else {
      const err = new Error('folder is not allowed!')
      err.file = {}
      callback(err)
    }
    dropBox.setAttribute('class', 'dragleave')
    // lastenter = null // 解决dragleave父子元素之间的拖拽问题
    e.preventDefault()
  })
}



// WEBPACK FOOTER //
// ./src/components/upload/upload_vue/upload-drop.js